/**
 * ExamNavigation Component
 * Question navigator grid for exam
 */
import { Flag, Check } from 'lucide-react';

const ExamNavigation = ({
  questions,
  currentIndex,
  answers,
  flagged,
  blockInfo,
  onNavigate,
  isQuestionInCurrentBlock,
  isQuestionInCompletedBlock
}) => {
  return (
    <div className="grid grid-cols-10 gap-1">
      {questions.map((q, idx) => {
        const isAnswered = answers[q.question_id]?.length > 0;
        const isFlagged = flagged.has(q.question_id);
        const isCurrent = idx === currentIndex;
        const inCurrentBlock = isQuestionInCurrentBlock(idx, blockInfo);
        const inCompletedBlock = isQuestionInCompletedBlock(idx);
        
        return (
          <button
            key={q.question_id}
            onClick={() => inCurrentBlock && !inCompletedBlock && onNavigate(idx)}
            disabled={!inCurrentBlock || inCompletedBlock}
            className={`
              relative w-8 h-8 text-xs font-medium rounded transition-all
              ${isCurrent 
                ? 'bg-[#0047AB] text-white ring-2 ring-[#0047AB]/50' 
                : inCompletedBlock
                  ? 'bg-slate-300 dark:bg-slate-600 text-slate-500 cursor-not-allowed'
                  : !inCurrentBlock
                    ? 'bg-slate-200 dark:bg-slate-700 text-slate-400 cursor-not-allowed'
                    : isAnswered 
                      ? 'bg-[#0047AB]/20 text-[#0047AB] hover:bg-[#0047AB]/30' 
                      : 'bg-slate-100 dark:bg-slate-800 hover:bg-slate-200'
              }
            `}
            data-testid={`nav-question-${idx + 1}`}
          >
            {idx + 1}
            {isFlagged && (
              <Flag className="absolute -top-1 -right-1 w-3 h-3 text-orange-500 fill-orange-500" />
            )}
            {inCompletedBlock && isAnswered && (
              <Check className="absolute -top-1 -right-1 w-3 h-3 text-green-500" />
            )}
          </button>
        );
      })}
    </div>
  );
};

export default ExamNavigation;
